import {MainPage} from "./MainPage";
let ReactDOM = require("react-dom");
import './Bootstrap.css';
import * as React from "react";
import "regenerator-runtime/runtime.js";
import {DocumentManager} from "./Manager/PDFManager/DocumentManager";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
WpAjaxPost.SetGlobalVar(rnImporterVar);

let documentManager=new DocumentManager();
declare let require:any;
let context=require.context("./", true, /(?<!test)(?<!\.d)\.tsx?$/);
let library:any={};
for(let key of context.keys())
{
    library[key.substring(0,key.lastIndexOf('.'))]=key;
}

let lN='PDFImporter';
export default function  (libraryName) {
    libraryName='./'+libraryName.substring(lN.length+1);//removed /InternalShared and adding ./

    if(library[libraryName]==null)
        throw 'Library not found '+libraryName;

    return context(library[libraryName]);


}


ReactDOM.render(<MainPage DocumentManager={documentManager}/>,document.getElementById('app'))